export const JOB_CATEGORIES: string[] = [
  'Teachers',
  'Professors',
  'Trainers',
  'Instructors',
  'Coaches',
  'Academic Mentors'
];